// Module
var code = "";
// Exports
var _module_exports = code;;
var path = 'app/library/PdfViewer/directive/template/pdfViewer.directive.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;